import { Phone, ExternalLink, FileText } from "lucide-react";
import { trackClick } from "@/lib/clickTracking";

/**
 * CTA dual + link secundario para descargar el dossier PDF (si existe).
 *  - "Reservar online" → link externo (booking_url)
 *  - "Quiero que me llamen" → scroll al formulario (#reservar)
 *  - "Descargar dossier PDF" → link a trip.pdf_url (opcional)
 */
export default function BookingCTAs({
  trip,
  variant = "primary",
  className = "",
  size = "md",
  showPdf = true,
}) {
  const isOnDark = variant === "on-dark";
  const sizes = size === "sm" ? "!py-3 !px-6 text-sm" : "";

  if (trip.sold_out) {
    return (
      <div className={`flex flex-col items-start gap-3 ${className}`}>
        <div className="flex flex-col sm:flex-row flex-wrap gap-3">
          <span
            data-testid={`booking-soldout-${trip.slug}`}
            className={`inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 font-outfit font-semibold text-sm md:text-base ${
              isOnDark ? "bg-white/15 text-white border border-white/30" : "bg-brand-line text-brand-primary"
            } ${sizes}`}
          >
            Viaje completo · plazas agotadas
          </span>
          <a
            href="#reservar"
            data-testid={`booking-alternatives-${trip.slug}`}
            className={
              isOnDark
                ? `inline-flex items-center justify-center gap-2 rounded-full border border-white/40 text-white px-7 py-3.5 font-manrope font-medium text-sm md:text-base transition-all duration-300 hover:bg-white/10 ${sizes}`
                : `btn-primary ${sizes}`
            }
          >
            <Phone className="h-4 w-4" /> Ver fechas alternativas
          </a>
        </div>
        {showPdf && trip.pdf_url && (
          <a
            href={trip.pdf_url}
            target="_blank"
            rel="noopener noreferrer"
            download
            data-testid={`booking-pdf-${trip.slug}`}
            onClick={() => trackClick("dossier_pdf", { trip_slug: trip.slug, trip_name: trip.name })}
            className={`inline-flex items-center gap-2 text-sm font-medium underline decoration-dotted underline-offset-4 transition-colors ${
              isOnDark ? "text-white/80 hover:text-white" : "text-brand-primary/80 hover:text-brand-primary"
            }`}
          >
            <FileText className="h-4 w-4" /> Descargar dossier completo (PDF)
          </a>
        )}
      </div>
    );
  }

  return (
    <div className={`flex flex-col items-start gap-3 ${className}`}>
      <div className="flex flex-col sm:flex-row flex-wrap gap-3">
        {trip.booking_url && (
          <a
            href={trip.booking_url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`booking-online-${trip.slug}`}
            onClick={() => trackClick("booking_online", { trip_slug: trip.slug, trip_name: trip.name })}
            className={`btn-accent ${sizes}`}
          >
            Reservar online <ExternalLink className="h-4 w-4" />
          </a>
        )}
        <a
          href="#reservar"
          data-testid={`booking-callback-${trip.slug}`}
          className={
            isOnDark
              ? `inline-flex items-center justify-center gap-2 rounded-full border border-white/40 text-white px-7 py-3.5 font-manrope font-medium text-sm md:text-base transition-all duration-300 hover:bg-white/10 ${sizes}`
              : `btn-primary ${sizes}`
          }
        >
          <Phone className="h-4 w-4" /> Que me llame un asesor
        </a>
      </div>

      {showPdf && trip.pdf_url && (
        <a
          href={trip.pdf_url}
          target="_blank"
          rel="noopener noreferrer"
          download
          data-testid={`booking-pdf-${trip.slug}`}
          onClick={() => trackClick("dossier_pdf", { trip_slug: trip.slug, trip_name: trip.name })}
          className={`inline-flex items-center gap-2 text-sm font-medium underline decoration-dotted underline-offset-4 transition-colors ${
            isOnDark
              ? "text-white/80 hover:text-white"
              : "text-brand-primary/80 hover:text-brand-primary"
          }`}
        >
          <FileText className="h-4 w-4" /> Descargar dossier completo (PDF)
        </a>
      )}
    </div>
  );
}
